import { Moment } from 'moment';
import { useCallback, useEffect } from 'react';
import { useDatasetPanelDetailsQuery } from '../../../../queries/useDatasetPanelDetailsQuery';
import useAuthStore from '../../../../store/authStore';
import { useActiveMarker, useMarkerStore } from '../../../../store/markerStore';

export const useDatasetParameters = (
  markerId: string,
  namePanel: string,
  coordinates: number[],
  datasetId: string
) => {
  const point = useActiveMarker();
  const setCellSize = useMarkerStore((state) => state.setCellSize);
  const setLandRelation = useMarkerStore((state) => state.setLandRelation);
  const setWaterDepth = useMarkerStore((state) => state.setWaterDepth);
  const userGroupPermissions = useAuthStore(
    (state) => state.userGroupPermissions
  );

  const depthAndCellSizeQuery = useDatasetPanelDetailsQuery(
    coordinates,
    datasetId,
    !!markerId
  );

  useEffect(() => {
    if (depthAndCellSizeQuery.data && markerId) {
      const { waterDepth, gridCellSize, landRelation } =
        depthAndCellSizeQuery.data;

      setWaterDepth(markerId, namePanel, waterDepth);
      setCellSize(markerId, namePanel, gridCellSize);
      setLandRelation(markerId, namePanel, landRelation);
    }
  }, [
    depthAndCellSizeQuery.data,
    markerId,
    namePanel,
    setCellSize,
    setLandRelation,
    setWaterDepth,
  ]);

  useEffect(() => {
    if (!markerId) {
      return;
    }

    if (namePanel === 'Wind') {
      return;
    }

    if (depthAndCellSizeQuery.isError) {
      setWaterDepth(markerId, namePanel, null);
      setCellSize(markerId, namePanel, null);
      setLandRelation(markerId, namePanel, null);
    }
  }, [
    depthAndCellSizeQuery.isError,
    markerId,
    namePanel,
    setCellSize,
    setLandRelation,
    setWaterDepth,
  ]);

  const disabledDate = useCallback(
    (current: Moment): boolean => {
      if (!point || !userGroupPermissions[point?.id]?.[namePanel]) {
        return false;
      }

      // Can not select days outside dataset's time range
      return (
        (current &&
          current.isBefore(
            userGroupPermissions[point.id][namePanel].dateRange[0],
            'day'
          )) ||
        (current &&
          current.isAfter(
            userGroupPermissions[point.id][namePanel].dateRange[1],
            'day'
          ))
      );
    },
    [userGroupPermissions, namePanel, point]
  );

  return {
    disabledDate,
  };
};
